<template>
  <div class="d-flex">
    <b-form method="post" enctype="multipart/form-data" :action="url" ref="contactImportsForm">
      <input type="hidden" :value="csrfToken" name="authenticity_token"/>
      <b-form-file accept=".csv"
                   type="file"
                   class="d-none"
                   name="file"
                   ref="fileInput"
                   v-model="file"/>
      <b-link @click="selectFile">{{ title || "Bulk Import" }}</b-link>
    </b-form>
  </div>
</template>
<script>

import FileInput from "../../Common/FileInput";
import GeneralMixins from "../../../mixins/GeneralMixins";

export default {
  props: ['url', 'title'],

  data() {
    return {
      file: null
    }
  },

  watch: {
    file: function (val) {
      if (val) {
        this.$refs.contactImportsForm.submit();
        console.log('tst');
      }
    }
  },

  methods: {
    updateFile: function (file) {
      console.log(file);
    },

    selectFile: function () {
      this.$refs.fileInput.$el.childNodes[0].click()
    }
  },

  components: {FileInput},
  mixins: [GeneralMixins]
}
</script>